<template>
	<div class="widget-min-box">
		<div class="tv-iframe-wrapper">
			<iframe id="tv-iframe" :src="`${this.$helpers.api_url()}/tv4/?symbol=${data.market_symbol}&technical_id=${data.id}&token=${this.$store.state.accessToken}&${new Date().getTime()}`" style="border:none;width: 100%;display: inline-block;height: 750px;"></iframe>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.tv-iframe-wrapper {
		width: 100%;
	}

	div.right {
		display : none !important;
	}
</style>

<script>
	// این کامپوننت برای نمایش تحلیل ذخیره شده کاربر استفاده میشود
	export default {
		name: 'ViewTechnicalComponent',
		props: ['data'],
		components: {},
		data: function () {
			return {}
		},
		mounted() {
			// در صورتی که منوی داشبورد مخفی بود نمایش داده شود
			var item = document.getElementsByClassName('bar-menu-dashboard-box');
			item[0].style.display = "";
		},
		methods: {}
	}
</script>